"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserMDStyled = exports.SectionHeading = exports.Section = exports.SearchStyled = exports.ButtonContainer = exports.Button = exports.SideBarButton = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const UserMD_1 = __importDefault(require("@kyruus/react-ikons/UserMD"));
const Search_1 = __importDefault(require("@kyruus/react-ikons/Search"));
const button_1 = require("@kyruus/button");
const breakpoints_1 = require("../../../lib/constants/breakpoints");
exports.SideBarButton = (0, styled_1.default)(button_1.ButtonLink) `
  width: 100%;
  text-align: center;
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.Button = (0, styled_1.default)(exports.SideBarButton) `
  margin: 0;
`;
exports.ButtonContainer = (0, styled_1.default)('div') `
  background: ${(0, ui_theme_1.fromTheme)('color_button_secondary')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_large')};
  width: ${breakpoints_1.SIDEBAR_WIDTH};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.SearchStyled = (0, styled_1.default)(Search_1.default) `
  color: ${(0, ui_theme_1.fromTheme)('color_border_secondary')};
`;
exports.Section = (0, styled_1.default)('section') `
  display: flex;

  svg {
    min-width: ${(0, ui_theme_1.fromTheme)('font_size_heading_3')};
    min-height: ${(0, ui_theme_1.fromTheme)('font_size_heading_3')};
    margin-right: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }

  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
`;
exports.SectionHeading = (0, styled_1.default)('h3') `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  margin: 0 0 ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
`;
exports.UserMDStyled = (0, styled_1.default)(UserMD_1.default) `
  color: ${(0, ui_theme_1.fromTheme)('color_border_secondary')};
`;
//# sourceMappingURL=styles.js.map